import { z } from "zod";

// Apart from the rest of the schemas, whose messages bring the whole of the invoices copy: the
// list route validates its search with this, and a route's search rides in every screen's first load.

/** What a row on the list reads as; Overdue is worked out from the company's today. */
export const LIST_STATUSES = [
  "draft",
  "unpaid",
  "partly_paid",
  "overdue",
  "paid",
  "cancelled",
] as const;

/**
 * Absent is the default: every status, any client, the current year. A year is the one it starts
 * in, India's financial year or elsewhere the calendar year; `all` is every year. `q` matches a
 * number or a client's name.
 */
export const invoiceListSearch = z.object({
  q: z.string().trim().min(1).max(100).optional().catch(undefined),
  status: z.enum(LIST_STATUSES).optional().catch(undefined),
  client: z.string().min(1).optional().catch(undefined),
  year: z
    .union([z.literal("all"), z.int().min(2000).max(9999)])
    .optional()
    .catch(undefined),
});

export type ListStatus = (typeof LIST_STATUSES)[number];
/** `send` opens the Send dialog: Send again, after a draft finalised but its email did not go. */
export const invoiceSearch = z.object({
  send: z.literal(true).optional().catch(undefined),
});

export type InvoiceListSearch = z.infer<typeof invoiceListSearch>;
